import Cookie from "js-cookie";
export default class DetectCurrentUser {
  constructor() {
    const hubspotUtk = Cookie.get("hubspotutk");

    if (hubspotUtk) {
      (async () => {
        await this.getAndPassInfoAboutCurrentUser(hubspotUtk);
      })();
    }
  }

  async getAndPassInfoAboutCurrentUser(hubspotUtk) {
    const currentTimestamp = Math.floor(Date.now() / 1000);

    const req = await fetch(`/wp-json/api/v1/current-user/?hutk=${hubspotUtk}&t=${currentTimestamp}`, {
      method: "GET",
      cache: "no-cache"
    });

    const data = await req.json();

    if (!data.error) {
      const cid = data.data.cid;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        cid: cid
      });
      window.dataLayer.push({
        event: "GAEvent",
        eventCategory: "User",
        eventAction: "User_detected",
        eventLabel: cid,
      });
    }
  }
}
